import { render, staticRenderFns } from "./Taiwan.vue?vue&type=template&id=26d85311&"
import script from "./Taiwan.vue?vue&type=script&lang=js&"
export * from "./Taiwan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26d85311')) {
      api.createRecord('26d85311', component.options)
    } else {
      api.reload('26d85311', component.options)
    }
    module.hot.accept("./Taiwan.vue?vue&type=template&id=26d85311&", function () {
      api.rerender('26d85311', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/countries/Taiwan.vue"
export default component.exports